import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { Colours, PillCaption, getLanguageFromLocale } from '@ratehub/base-ui';

import PRODUCT_TYPES from '../definitions/ProductTypes';
import getCardProductTypeName from '../functions/getCardProductTypeName';


function CreditCardCategoryPill({ category, className, ...otherProps }) {
    const intl = useIntl();
    const languageCode = getLanguageFromLocale(intl.locale);

    return (
        <PillCaption
            className={className}
            {...getPillProps(category, languageCode)}
            {...otherProps}
        />
    );
}

CreditCardCategoryPill.propTypes = {
    category: PropTypes.oneOf(Object.values(PRODUCT_TYPES)).isRequired,
    className: PropTypes.string,
};


const PILL_BACKGROUND_COLOUR = {
    [PRODUCT_TYPES.TRAVEL]: {
        backgroundColour: Colours.BLUEBERRY_LIGHTEST,
    },
    [PRODUCT_TYPES.CASH_BACK]: {
        backgroundColour: Colours.MINT_LIGHT,
    },
    [PRODUCT_TYPES.LOW_INTEREST]: {
        backgroundColour: Colours.GRAPE_LIGHTEST,
    },
    [PRODUCT_TYPES.BALANCE_TRANSFER]: {
        backgroundColour: Colours.WATERMELON_LIGHTEST,
    },
    [PRODUCT_TYPES.SECURED]: {
        backgroundColour: Colours.TANGERINE_LIGHTEST,
    },
    // when we are ready for Store Credit, YUZU_LIGHTEST it is
    // [PRODUCT_TYPES.STORE_CREDIT]: {
    //     backgroundColour: Colours.YUZU_LIGHTEST,
    // },
};

function getPillProps(category, languageCode) {
    // at least for now we represent Store Credit cards as Cash Back cards
    if (category === PRODUCT_TYPES.STORE_CREDIT) {
        category = PRODUCT_TYPES.CASH_BACK;
    }

    const backgroundColour = PILL_BACKGROUND_COLOUR[category]?.backgroundColour;

    if (!backgroundColour) {
        throw new RangeError(`CreditCardCategoryPill -- unexpected category: ${category}`);
    }

    return {
        backgroundColour: backgroundColour,
        message: getCardProductTypeName({ productType: category }, languageCode),
    };
}


export default CreditCardCategoryPill;


